

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const invoiceEditAtom = atom({key:'invoiceEditAtom', default:{}});

const invoiceAtom = atom({key:'invoicePropsAtom', default:{item_info:[],product_type:[], 
    amount_summary:[],bulk_action:[],created_officer:[],currency:[], discount_type:[],
     display_column:[], filtering_criteria:[],invoice_info:[],payment_term:[], plans:[], 
     sales_officer:[], tax:[], warehouse:[]}});


export  const SetInvoiceEdit = () => useSetRecoilState(invoiceEditAtom);
export  const GetInvoiceEdit = () => useRecoilValue(invoiceEditAtom);
export const ResetInvoiceEdit = ()=> useResetRecoilState(invoiceEditAtom);


export  const SetInvoiceData = () => useSetRecoilState(invoiceAtom);
export  const GetInvoiceData = () => useRecoilValue(invoiceAtom);




